import { useNavigate } from 'react-router-dom';
import { articles } from '@/mocks/articles';

export default function LatestNews() {
  const navigate = useNavigate();

  const handleArticleClick = (id: string) => {
    navigate(`/article/${id}`);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const handleViewAll = () => {
    navigate('/category/football');
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const displayArticles = articles.slice(0, 6);

  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-end justify-between mb-10 md:mb-12">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
              最新体育资讯
            </h2>
            <p className="text-foreground-600 text-sm md:text-base">
              第一时间获取全球体育动态
            </p>
          </div>
          <button
            onClick={handleViewAll}
            className="hidden sm:inline-flex items-center gap-1.5 text-sm font-medium text-primary-600 hover:text-primary-700 cursor-pointer whitespace-nowrap transition-colors"
          >
            查看全部资讯
            <i className="ri-arrow-right-line text-sm"></i>
          </button>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {displayArticles.map((article, index) => (
            <article
              key={article.id}
              onClick={() => handleArticleClick(article.id)}
              className={`group bg-background-100 rounded-xl overflow-hidden cursor-pointer transition-all duration-200 hover:bg-background-200/70 border border-transparent hover:border-background-300/60 ${
                index === 0 ? 'md:col-span-2 lg:col-span-2 md:flex' : ''
              }`}
            >
              <div className={`overflow-hidden ${index === 0 ? 'md:w-2/5 md:flex-shrink-0' : 'w-full'}`}>
                <img
                  src={article.image}
                  alt={article.title}
                  className={`w-full object-cover transition-transform duration-500 group-hover:scale-105 ${
                    index === 0 ? 'h-48 md:h-full' : 'h-44'
                  }`}
                  loading={index > 2 ? 'lazy' : undefined}
                />
              </div>
              <div className={`p-4 md:p-5 ${index === 0 ? 'md:flex-1 md:flex md:flex-col md:justify-center' : ''}`}>
                <div className="flex items-center gap-2 mb-2">
                  <span className="text-xs font-medium text-primary-600 bg-primary-50 px-2 py-0.5 rounded-full">
                    {article.category}
                  </span>
                  <span className="text-xs text-foreground-500">{article.date}</span>
                </div>
                <h3 className={`font-heading font-semibold text-foreground-950 mb-2 group-hover:text-primary-600 transition-colors line-clamp-2 ${
                  index === 0 ? 'text-lg md:text-xl' : 'text-base'
                }`}>
                  {article.title}
                </h3>
                <p className={`text-foreground-600 line-clamp-2 mb-3 ${index === 0 ? 'text-sm' : 'text-xs'}`}>
                  {article.excerpt}
                </p>
                <div className="flex items-center gap-3 text-xs text-foreground-500">
                  <span className="flex items-center gap-1">
                    <i className="ri-time-line"></i>
                    {article.readTime}
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-user-line"></i>
                    {article.author}
                  </span>
                </div>
              </div>
            </article>
          ))}
        </div>

        <div className="mt-8 text-center sm:hidden">
          <button
            onClick={handleViewAll}
            className="inline-flex items-center gap-1.5 text-sm font-medium text-primary-600 hover:text-primary-700 cursor-pointer whitespace-nowrap transition-colors"
          >
            查看全部资讯
            <i className="ri-arrow-right-line text-sm"></i>
          </button>
        </div>
      </div>
    </section>
  );
}